<template>
<!-- Feature Section start -->
<section id="feature" class="feature p-2">
    <div class="feature-decor">
        <div class="feature-circle1"><img :src='"../assets/images/feature2.png"' alt=""></div>
    </div>
    <div class="container">
        <div class="row">
            <div class="feature-phone">
                <!-- <img :src='"../assets/images/222.png"' class="img-fluid" alt=""> !-->
            </div>
            <div class="offset-lg-4 col-lg-8">
                <div class="row">
                    <div class="col-sm-12 mrgn-md-top">
                        <h2 class="title"><span>CLEAN TOUCH PROTECT</span> GARANTI VOTRE SÉCURITÉ</h2>
                    </div>
                    <div class="col-12 col-md-6">
                        <ul class="feature-style">
                            <li>
                                <div class="feature-icon">
                                    <span style="color:#19D7DC;font-size:24px">
                                        <i class="fas fa-clock"></i>
                                    </span>
                                </div>
                                <div class="feature-subtitle">
                                    <h3>Protection longue durée</h3>
                                </div>
                                <div>
                                    <p> 24h/24, 7j/7 entre 2 nettoyages </p>
                                </div>
                            </li>
                            <li>
                                <div class="feature-icon">
                                    <span style="color:#19D7DC;font-size:24px">
                                        <i class="fas fa-shield-virus"></i>
                                    </span>
                                </div>
                                <div class="feature-subtitle">
                                    <h3>Protège les zones de contact</h3>
                                </div>
                                <div>
                                    <p>Toutes les zones sont désormais protégées </p>
                                </div>
                            </li>
                            <li>
                                <div class="feature-icon">
                                    <span style="color:#19D7DC;font-size:24px">
                                        <i class="fas fa-arrow-down"></i>
                                    </span>
                                </div>
                                <div class="feature-subtitle">
                                    <h3>Inhibition de la croissance </h3>
                                </div>
                                <div>
                                    <p>de 99.99% des germes testés (tests conformes à la norme ISO 22196) </p>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="col-12 col-md-6 sm-m-top">
                        <ul class="feature-style">
                            <li>
                                <div class="feature-icon">
                                    <span style="color:#19D7DC;font-size:24px">
                                        <i class="fas fa-virus-slash"></i>
                                    </span>
                                </div>
                                <div class="feature-subtitle">
                                    <h3>Réduit la population bactérienne</h3>
                                </div>
                                <div>
                                    <p>Jusqu'à 4 Logs </p>
                                </div>
                            </li>
                            <li>
                                <div class="feature-icon">
                                    <span style="color:#19D7DC;font-size:24px">
                                        <i class="fas fa-soap"></i>
                                    </span>
                                </div>
                                <div class="feature-subtitle">
                                    <h3>Evite la formation du biofilm</h3>
                                </div>
                                <div>
                                    <p>Grâce a son procédé innovant </p>
                                </div>
                            </li>
                            <li>
                                <div class="feature-icon">
                                    <span style="color:#19D7DC;font-size:24px">
                                        <i class="fas fa-chart-line"></i>
                                    </span>
                                </div>
                                <div class="feature-subtitle">
                                    <h3>Actif immédiatement</h3>
                                </div>
                                <div>
                                    <p>Et dure jusqu'à cinq ans </p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- Feature Section End -->
</template>

<script>
export default {
    name: 'feature'
}
</script>



// WEBPACK FOOTER //
// src/components/feature.vue